import { useCallback, useState } from "react";
import { ShareTemplateMain } from "./Style";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Button, Image, notification } from "antd";
import { useSession } from "next-auth/react";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useAppSelector } from "@/hooks/redux";
import { getDashBoardState } from "@/redux/store";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useGetEnvQuery } from "@/redux/api/commonApi";
import axios from "axios";

dayjs.extend(customParseFormat);

export default function UnauthorizedTemplate({
  projectInfo,
  projectShareMember,
  userProjectPermission,
}: {
  projectInfo: MyProjectItemDetail;
  projectShareMember: UserProjectShareType[];
  userProjectPermission: string;
}) {
  const { t } = useTranslation("common");
  const session = useSession();
  const router = useRouter();
  const { share_id } = router.query;
  const [api, contextHolder] = notification.useNotification();
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);


  const { workspaceDetail } = useAppSelector(
    (store) => getDashBoardState(store).workspaceInfo
  );
  console.log("workspaceDetail: ", workspaceDetail);

  const handleRequest = async () => {
    try {
      setIsLoading(true);
      // templateName, projectId, shareId, sharePermission, shareType

      const body = {
        templateName: "requestProjectCommentPermission",
        projectId: share_id,
        userId: session?.data?.user?.id,
        sharePermission: "view",
        shareType: "user",
      };

      const result = await axios.post(
        "/api/workspace/send-request-permission-email",
        body
      );

      console.log("sendRequestPermission result: ", result.data);
    } catch (error) {
      console.log("sendRequestPermission error: ", error);
    } finally {
      setIsLoading(false);
      api.success({
        message: (
          <span style={{ color: "#ffffff" }}>
            {t("Permission has been requested successfully.")}
          </span>
        ),
        duration: 4,
        placement: "top",
        style: {
          width: "700px",
          backgroundColor: "#2bab62",
          position: "relative",
          borderRadius: "8px",
          padding: "13px 30px",
        },
        closeIcon: <span style={{ color: "#ffffff" }}>X</span>,
        icon: <CheckCircleOutlined style={{ color: "white" }} />,
      });
      setStep(2);
    }
  };

  const goToDashboard = () => {
    router.push("/dashboard");
  };

  return (
    <ShareTemplateMain>
      {step === 1 && (
        <div className="unauthorized-container">
          <Image src="/images/lock.png" alt="lock-img" preview={false} />
          <div className="title">
            {t("You don’t have permission to access this video.")}
          </div>
          <div className="sub-text">
            {t(
              "Would you like to view or edit this video? If you would like to share a video, please ask the owner for permission."
            )}
          </div>
          <Button
            className="Request-button"
            loading={isLoading}
            onClick={handleRequest}
          >
            {t("Request Permission")}
          </Button>
        </div>
      )}
      {step === 2 && (
        <div className="unauthorized-container">
          <Image src="/images/bird.png" alt="lock-img" preview={false} />
          <div className="title">{t("Permission has been requested.")}</div>
          <div className="sub-text">
            {t(
              "You will receive an email once the video owner approves your request."
            )}
          </div>
          <Button className="Request-button" onClick={goToDashboard}>
            {t("Go dashboard")}
          </Button>
        </div>
      )}
      {contextHolder}
    </ShareTemplateMain>
  );
}
